import {SavedLocation} from "components/src/auth/SavedLocation";
import {XSRF} from "components/src/auth/Xsrf";
import {LocaleSelector} from "components/src/common/LocaleSelector";
import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import DOMPurify from "dompurify";
import {useRef} from "react";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from 'react-bootstrap/Form';
import {useSearchParams} from "react-router-dom";

export const PortalLogin = () =>
{
    const [searchParams] = useSearchParams();

    /**
     * A ref to the hidden _csrf form field
     */
    const csrFieldRef = useRef<HTMLInputElement>(null);

    const loginURL: string = "/api/login"

    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    const sanitizeHTML = (html : string) => {
        return {__html: DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })};
    }

    // back-end will add the logout parameter when the user is logged out
    if (searchParams.has("logout")) {
        SavedLocation.clearSavedLocation();
    }

    function onSubmit()
    {
        if (csrFieldRef.current !== null) {
            csrFieldRef.current.value = XSRF.getCookie();
        }
    }

    return (
        <>
        {t(['portal.login.header']).length > 0 && <div dangerouslySetInnerHTML={sanitizeHTML(t(["portal.login.header"]))} />}
        <Form method="post" action={loginURL} onSubmit={onSubmit} className="w-100 p-4 shadow-sm rounded bg-body">
            <div className="mb-4 text-center">
                <h2>{t("login.please-login")}</h2>
            </div>

            {searchParams.has("error") && <Alert variant="danger">{t('portal.login.login-failure')}</Alert>}

            <FloatingLabel label={t('portal.login.email-label')} className="text-secondary mb-3">
                <Form.Control type="email" name="username" placeholder="Email" autoFocus/>
            </FloatingLabel>

            <FloatingLabel label={t('portal.login.password-label')} className="text-secondary mb-3">
                <Form.Control type="password" name="password" placeholder="Password"/>
            </FloatingLabel>

            <a href="/forgot-password">{t('portal.login.forgot-password')}</a>

            <Button variant="success" type="submit" className="w-100 mt-4">
                {t("portal.login.login-button")}
            </Button>

            <LocaleSelector className="w-auto mt-4" />

            {t(['portal.legal-notice']).length > 0 &&
                <div className="mt-2" dangerouslySetInnerHTML={sanitizeHTML(t(["portal.legal-notice"]))} />
            }

            <input name="_csrf" type="hidden" ref={csrFieldRef} value=""/>
        </Form>
        {t(['portal.login.footer']).length > 0 && <div dangerouslySetInnerHTML={sanitizeHTML(t(["portal.login.footer"]))} />}
        </>
    );
}
